import {NEED} from '../content/consts';
import {TPL,ltFor,ltText} from '../content/issues';
import {S,log} from './state';
import {clamp} from './util';

export function lteTick(){
  let att=false;
  S.lte=(S.lte||[]).filter((x:any)=>{
    if(S.m===x.from){log(`Langzeitwirkung: „${x.t}“ zeigt jetzt Folgen (${ltText(x.e)}).`,(x.e.b||0)<0||Object.values<any>(x.e.sev||{}).some((v:any)=>v>0)?'bad':'good');att=true}
    if(S.m>=x.from&&S.m<x.from+x.dur){const e=x.e,f=1/x.dur;
      if(e.gr)S.lawGr+=e.gr*f;if(e.al)S.lawAl+=e.al*f;if(e.b)S.lawB+=e.b*f;
      for(const k in (e.sev||{}))if(S.issues[k])S.issues[k].sev=clamp(S.issues[k].sev+e.sev[k]*f,0,100);
      for(const g in (e.g||{}))S.bonus[g]+=e.g[g]*f}
    return S.m<x.from+x.dur});
  return att;
}
export function pushLT(L?:any){
  if(L.rep||L.bestand||L.fx?.nov)return; // Version 9: Novellen bringen keine zweite Langzeitwirkung
  const T=TPL(L.iss,L.tpl||0),lt=ltFor(T,L.fx,L.p||{},L.iss);
  if(lt){(S.lte=S.lte||[]).push({lid:L.id,t:L.t,from:S.m+6+lt.delay,dur:lt.dur,e:lt});}
}
export const needFor=(fx?:{gg?:boolean}|null)=>fx&&fx.gg?420:NEED;
